import createSingleResourceReducer from 'shared/app/stale-reducers/single-resource-reducer';

import { FETCH_SIMILAR_ITEMS } from '../actions/types';

const { reducer } = createSingleResourceReducer({
  startAction: FETCH_SIMILAR_ITEMS,
});

export default reducer;
